<template>
<div class="chapter">
<div class="inner_page">
<p class="sp-brk"> </p>
<p class="bmh"><span class="epub-i">Contents</span></p>
<p class="toc-bot"><span href="#/xhtml/title#tit" title="Link target outside of Sample">Title Page</span></p>
<p class="toc">Chapter 1: <a href="#/xhtml/chapter1#ch1">Slipping on the Dog</a></p>
<p class="toc">Chapter 2: <a href="#/xhtml/chapter2#ch2">Because a Fisher Softly Creeping, Left Disease While I Was Sleeping</a></p>
<p class="toc">Chapter 3: <span href="#/xhtml/chapter3#ch3" title="Link target outside of Sample">It’s Amazing How You Can Spit Rice Through My Heart</span></p>
<p class="toc">Chapter 4: <span href="#/xhtml/chapter4#ch4" title="Link target outside of Sample">I’m Gonna Shoot You Right Down, Ride Off with Your Feet</span></p>
<p class="toc">Chapter 5: <span href="#/xhtml/chapter5#ch5" title="Link target outside of Sample">All My Jeans Are Filled</span></p>
<p class="toc">Chapter 6: <span href="#/xhtml/chapter6#ch6" title="Link target outside of Sample">It’s Been a Hard Day’s Night, I Should Be Sleeping on Kellogg’s</span></p>
<p class="toc">Chapter 7: <span href="#/xhtml/chapter7#ch7" title="Link target outside of Sample">They Say Love Is More or Less a Gibbon Thing</span></p>
<p class="toc">Chapter 8: <span href="#/xhtml/chapter8#ch8" title="Link target outside of Sample">Our Love Is Like a Chip on the Ocean</span></p>
<p class="toc">Chapter 9: <span href="#/xhtml/chapter9#ch9" title="Link target outside of Sample">We Will Iron Each Other</span></p>
<p class="toc">Chapter 10: <span href="#/xhtml/chapter10#ch10" title="Link target outside of Sample">Something in the Way She Moos</span></p>
<p class="toc">Chapter 11: <span href="#/xhtml/chapter11#ch11" title="Link target outside of Sample">Give Me My Porpoise When You Get Home</span></p>
<p class="toc">Chapter 12: <span href="#/xhtml/chapter12#ch12" title="Link target outside of Sample">I Was Feeling Kinda Seasick but the Crowd Called Arthur Moor</span></p>
<p class="toc">Chapter 13: <span href="#/xhtml/chapter13#ch13" title="Link target outside of Sample">Some Shy Bruised Eyes Please Go Away</span></p>
<p class="toc">Chapter 14: <span href="#/xhtml/chapter14#ch14" title="Link target outside of Sample">The Colors of the Rambo, So Pretty in Disguise</span></p>
<p class="toc">Chapter 15: <span href="#/xhtml/chapter15#ch15" title="Link target outside of Sample">Old Pirates, Yes, They’re Rabbi</span></p>
<p class="toc">Chapter 16: <span href="#/xhtml/chapter16#ch16" title="Link target outside of Sample">Start Spreading Manures</span></p>
<p class="toc-bot">Chapter 17: <span href="#/xhtml/chapter17#ch17" title="Link target outside of Sample">And All the Lettuce Was Alone</span></p>
<p class="toc"><span href="#/xhtml/map#map" title="Link target outside of Sample">Map</span></p>
<p class="toc"><span href="#/xhtml/authors_note#aun" title="Link target outside of Sample">Author’s Note</span></p>
<p class="toc"><span href="#/xhtml/acknowledgments#ack" title="Link target outside of Sample">Acknowledgments</span></p>
<p class="toc"><span href="#/xhtml/adcard#adc" title="Link target outside of Sample">Also by Colin Cotterill</span></p>
<p class="toc"><span href="#/xhtml/aboutauthor#ata" title="Link target outside of Sample">About the Author</span></p>
<p class="toc"><span href="#/xhtml/copyright#crp" title="Link target outside of Sample">Copyright</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?39d7894d